import clsx from 'clsx';
import type { FC, PropsWithChildren } from 'react';

import classes from './classes.module.css';

type Props = {
  className?: string;
};

export const CenterContainer: FC<PropsWithChildren<Props>> = ({
  children,
  className,
}) => <div className={clsx(classes.container, className)}>{children}</div>;
